import { render, staticRenderFns } from "./Workload_statistics.vue?vue&type=template&id=1ec91c63&scoped=true"
import script from "./Workload_statistics.vue?vue&type=script&lang=js"
export * from "./Workload_statistics.vue?vue&type=script&lang=js"
import style0 from "./Workload_statistics.vue?vue&type=style&index=0&id=1ec91c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec91c63",
  null
  
)

export default component.exports